import App from './app/store';

const store = {
    app: new App()
};

export default store;
